<template>
  <div class="report-container">
    <transition name="fade">
      <b-card v-if="answer" class="report-card shadow-lg">
        <div class="header">
          <h2 class="report-title">
            {{ answer.test ? answer.test.name : '' }}
          </h2>
          <p class="subtitle">
            {{ answer.test ? answer.test.description : '' }}
          </p>
        </div>

        <div class="actions">
          <b-button variant="outline-danger" class="action-btn" @click="handlePrintDesiNeuroscience()">
            Générer PDF
          </b-button>
          <b-button variant="outline-success" class="action-btn" @click="downloadExcel">
            Télécharger Excel
          </b-button>
        </div>
        <b-modal id="modal-project" size="xl" hide-footer>

          <template #modal-title>
            Choix d'impression
          </template>
          <h5>Option de l'impression</h5>
          <p>Si aucune option n’est cochée, le rapport s’imprimera uniquement. </p>
          <input type="checkbox" id="cover" v-model="cover">
          <label for="cover">Cover</label>
          </br>
          <input type="checkbox" v-model="lexique" id="lexique">
          <label for="lexique">Lexique</label>
          </br>

          <b-button class="mt-4" block @click="printNeuroscienceReport()">OK</b-button>
        </b-modal>

        <section class="report-section glass-box">
          <h4 class="section-title">Informations du répondant</h4>
          <ul class="info-list">
            <li>
              <span>Répondant :</span>
              {{ answer.user ? (answer.user.fullname || answer.user.id) : '' }}
            </li>
            <li>
              <span>Entreprise :</span>
              {{ answer.user && answer.user.company ? answer.user.company : 'N/A' }}
            </li>
            <li>
              <span>Statut :</span>
              {{ answer.finished ? '✅ Terminé' : '⌛ En cours' }}
            </li>
            <li>
              <span>Date de création :</span>
              {{ formatDate(answer.creation_date) }}
            </li>
            <li>
              <span>Date de modification :</span>
              {{ formatDate(answer.modification_date) }}
            </li>
          </ul>
        </section>

        <section class="report-section">
          <h4 class="section-title">Scores par item</h4>
          <b-table striped hover bordered :items="answer.scores && answer.scores.items ? answer.scores.items : []"
            :fields="itemFields" class="modern-table">
            <template #cell(percentage)="row">
              <span class="percent">
                {{ row.item.percentage ? row.item.percentage.toFixed(2) : '0.00' }} %
              </span>
            </template>

            <template #cell(groups)="row">
              {{ row.item.groups && row.item.groups.length ? row.item.groups.join(', ') : '-' }}
            </template>

            <template #cell(positions)="row">
              {{ row.item.positions && row.item.positions.length ? row.item.positions.join(', ') : '-' }}
            </template>

            <template #cell(groupPercentage)="row">
              <span class="percent">
                {{
                  row.item.groups && row.item.groups.length > 0 && row.item.groupPercentage
                    ? row.item.groupPercentage.toFixed(2) + ' %'
                    : '-'
                }}
              </span>
            </template>

          </b-table>
        </section>

        <section class="report-section">
          <h4 class="section-title">Scores par groupe</h4>
          <b-table striped hover bordered :items="answer.scores && answer.scores.groups ? answer.scores.groups : []"
            :fields="groupFields" class="modern-table">
            <template #cell(percentage)="row">
              <span class="percent">
                {{ row.item.percentage ? row.item.percentage.toFixed(2) : '0.00' }} %
              </span>
            </template>
          </b-table>
        </section>

        <section class="report-section glass-box">
          <h4 class="section-title">Score global</h4>

          <p class="global-score">
            <strong>Total :</strong>
            {{ answer.scores && answer.scores.global ? answer.scores.global.totalScore : '' }}
            /
            {{ answer.scores && answer.scores.global ? answer.scores.global.totalMax : '' }}
            <span class="percent">
              (
              {{
                answer.scores && answer.scores.global
                  ? answer.scores.global.percentage.toFixed(2)
                  : '0.00'
              }}
              %
              )
            </span>
          </p>

          <p class="global-score">
            <strong>Combinaison :</strong>
            <span class="percent">
              {{ answer.scores && answer.scores.combinaison ? answer.scores.combinaison : '-' }}
            </span>
          </p>
        </section>

      </b-card>

      <div v-else class="loading">
        <b-spinner class="custom-spinner" />
      </div>
    </transition>
  </div>
</template>



<script>
import axios from "axios";

export default {
  name: "NormatifReport",
  data() {
    return {
      answer: null,
      cover: false,
      lexique: false,
      itemFields: [
        { key: 'itemName', label: "Nom de l'item" },
        { key: 'score', label: 'Score' },
        { key: 'scoreMax', label: 'Score max' },
        { key: 'percentage', label: 'Pourcentage' },
        { key: 'groups', label: 'Groupe' },
        { key: 'positions', label: 'Position dans le groupe' },
        { key: 'groupPercentage', label: 'Pourcentage dans le groupe' }
      ],
      groupFields: [
        { key: 'groupName', label: 'Nom du groupe' },
        { key: 'score', label: 'Score' },
        { key: 'scoreMax', label: 'Score max' },
        { key: 'percentage', label: 'Pourcentage' }
      ]
    };
  },
  async mounted() {
    const qId = this.$route.query.id;
    if (!qId) return;
    try {
      const res = await axios.get("/api/normatif-answers/complete");
      this.answer = res.data.find(a => a.id == qId);
      console.log(this.answer)
    } catch (err) {
      console.error("Erreur lors du chargement du rapport:", err);
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleString();
    },
    async downloadExcel() {
      const id = this.$route.query.id;

      const response = await axios({
        url: "/api/excelEvaluationNeuroscienceQuestionnaire",
        method: "GET",
        params: { id },
        responseType: "blob",
      });

      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Normatif_" + id + ".xlsx";
      link.click();
    },
    handlePrintDesiNeuroscience() {
      this.$bvModal.show('modal-project');
    },
    printNeuroscienceReport() {
      const id = this.$route.query.id;

      this.$toast.info("La création du rapport est en cours.");
      try {
        window.open("https://desi.alorem.fr/printReportNeuroscience?id=" + id+"&cover="+this.cover+"&lexique="+this.lexique, "_blank");
        this.$bvModal.hide('modal-project');
      }
      catch (err) {
        this.$toast.error("Oops, Nous avons rencontré un probleme lors de la création du rapport !");
      }
    },
  },

};
</script>

<style scoped>
.report-container {
  max-width: 1100px;
  margin: auto;
  padding: 2rem;
  font-family: "Poppins", sans-serif;
}

.report-card {
  border-radius: 18px;
  padding: 2rem;
  background: linear-gradient(135deg, #ffffffcc, #f8f9fae6);
  backdrop-filter: blur(10px);
  border: none;
}

.header {
  text-align: center;
  margin-bottom: 2rem;
}

.report-title {
  font-size: 2rem;
  font-weight: 700;
  color: #4a148c;
}

.subtitle {
  color: #666;
  font-size: 1.1rem;
}

.actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 2rem;
}

.action-btn {
  padding: 0.6rem 1.4rem;
  border-radius: 30px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
}

.report-section {
  margin-top: 2rem;
}

.section-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #4a148c;
  margin-bottom: 1rem;
}

.glass-box {
  background: rgba(240, 240, 255, 0.6);
  border-radius: 12px;
  padding: 1rem 1.5rem;
  border: 1px solid rgba(200, 200, 200, 0.2);
}

.info-list {
  list-style: none;
  padding: 0;
}

.info-list li {
  padding: 0.4rem 0;
}

.info-list span {
  font-weight: 600;
  color: #333;
}

.modern-table {
  border-radius: 12px;
  overflow: hidden;
}

.modern-table thead {
  background: #4a148c;
  color: #fff;
}

.modern-table tbody tr:hover {
  background: #f1f0ff;
  transition: background 0.3s;
}

.percent {
  font-weight: 600;
  color: #4a148c;
}

.global-score {
  font-size: 1.1rem;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
}

.custom-spinner {
  width: 3.5rem;
  height: 3.5rem;
  color: #4a148c;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
